import BaseDatePicker from './BaseDatePicker.vue';

export default BaseDatePicker;

export { BaseDatePicker };
